<template>
  <div class="w-full">
    <span class="font-medium">{{ t("admin.tasks.activity.title") }}</span>
    <div v-for="item in history" :key="item.id" class="mt-4">
      <activity-history-item :item="item" :task="props.task" />
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import route from "ziggy-js";
import { defineProps, onMounted, watch, ref } from "vue";
import ActivityHistoryItem from "@/Tailwind/Components/ActivityHistoryItem";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  tenantId: String,
  task: Object,
});

onMounted(async () => {
  await loadActivity();
});

watch(props, async () => {
  reset();
  await loadActivity();
});

const history = ref([]);
const hasNextPage = ref(true);
const page = ref(1);

const reset = () => {
  history.value = [];
  hasNextPage.value = true;
  page.value = 1;
};

const loadActivity = async () => {
  if (!hasNextPage) {
    return;
  }

  const { data: response } = await axios.get(
    route("api.tasks.feed.index", {
      tenant: props.tenantId,
      task: props.task.id,
      page: page.value,
    })
  );

  history.value = response.data;

  if (response.links.next === null) {
    hasNextPage.value = false;
    return;
  }

  page.value = page.value + 1;
};
</script>
